import React from 'react'
import styled from 'styled-components'
import type { PaletteKeys } from '../../styled'
import addTransparencyToHex from '../../utils/addTransparencyToHex/addTransparencyToHex'

type DotProps = {
  colour: PaletteKeys
  className?: string
}

export const DOT_DIAMETER = 24

const Wrapper = styled.div<{ colour: PaletteKeys }>`
  border-radius: 100%;

  background-color: ${({ theme, colour }) => theme.palette[colour]};

  width: ${DOT_DIAMETER}px;
  height: ${DOT_DIAMETER}px;

  transition-property: outline;
  transition-duration: 0.3s;
  transition-timing-function: linear;

  outline-width: 0px;
  outline-style: solid;
  outline-color: ${({ theme, colour }) =>
    addTransparencyToHex(theme.palette[colour], 20)};
  :hover {
    outline-width: 4px;
  }
`

// Move this in care-office on the needed page
// this is not a reusable component
// todo
// we are using restProps here, because Popover needs special props
function Dot({ colour, className, ...restProps }: DotProps) {
  return <Wrapper className={className} colour={colour} {...restProps} />
}

export default Dot
